import { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { Store } from "@reduxjs/toolkit";
import { RootState } from "../redux/RootReducer";

export default function setupAxios(
    axios: AxiosInstance,
    store: Store<RootState>,
): void {
  axios.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        const state = store.getState();
        const accessToken = state.auth?.accessToken;

        if (accessToken && config.headers) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }

        return config;
      },
      (err: Error) => Promise.reject(err),
  );
}
